import { WebPushLinkType } from '../enums/WebPushLinkType';

export function capabilityToWebPushLinkType(capability: string) {
    switch (capability) {
        case 'pages':
            return WebPushLinkType.LandingPage;
        case 'blogposts':
            return WebPushLinkType.BlogPost;
        case 'listings':
            return WebPushLinkType.Listing;
        case 'homelists':
            return WebPushLinkType.HomeList;
        default:
            return WebPushLinkType.External;
    }
}
